<template>
  <div>
    <h1>Edit {{ item && item['@id'] }}</h1>

    <div
      v-if="created"
      class="alert alert-success"
      role="status">{{ created['@id'] }} created.</div>
    <div
      v-if="updated"
      class="alert alert-success"
      role="status">{{ updated['@id'] }} updated.</div>
    <div
      v-if="isLoading || deleteLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ error }}
    </div>
    <div
      v-if="deleteError"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ deleteError }}
    </div>

    <EXCMDailyPlanForm
      v-if="item"
      :handle-submit="onSendForm"
      :handle-update-field="updateField"
      :values="item"
      :errors="violations"
      :initial-values="retrieved" />

    <router-link
      v-if="item"
      :to="{ name: 'EXCMDailyPlanList' }"
      class="btn btn-default">Back to list</router-link>
    <button
      class="btn btn-danger"
      @click="del">Delete</button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMDailyPlanForm from './Form.vue'

export default {
  components: {
    EXCMDailyPlanForm
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'excmdailyplan/update/isLoading',
      error: 'excmdailyplan/update/error',
      deleteError: 'excmdailyplan/del/error',
      deleteLoading: 'excmdailyplan/del/isLoading',
      created: 'excmdailyplan/create/created',
      deleted: 'excmdailyplan/del/deleted',
      retrieved: 'excmdailyplan/update/retrieved',
      updated: 'excmdailyplan/update/updated',
      violations: 'excmdailyplan/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXCMDailyPlanList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'excmdailyplan/create/reset',
      deleteItem: 'excmdailyplan/del/del',
      delReset: 'excmdailyplan/del/reset',
      retrieve: 'excmdailyplan/update/retrieve',
      updateReset: 'excmdailyplan/update/reset',
      update: 'excmdailyplan/update/update',
      updateRetrieved: 'excmdailyplan/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmdailyplan ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
